module.exports = __webpack_public_path__ + "static/media/masih.e8885c93.jpg";